export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al contenedor"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subir packing list"])},
          "upload_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subir"])},
          "download_format_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar formato"])},
          "file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archivo"])},
          "click_to_upload": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para subir"])},
          "drag_and_drop_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["o arrastre y suelte el archivo"])},
          "title_how_complete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cómo completar el formato"])},
          "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["* Obligatorio"])},
          "replace_all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reemplazar todo"])}
        }
      }
    }
  })
}